@if (vm(); as v) {
  <div
    class="announcement-banner"
    [class]="'announcement-banner ' + v.modifier"
    [attr.role]="v.role"
    [attr.data-severity]="v.severity"
    data-testid="announcement-banner"
  >
    <div class="announcement-banner__msg">
      <lucide-icon [img]="v.icon" class="announcement-banner__icon" aria-hidden="true" />

      <!--
        Plain text ONLY. `message` is staff-authored but still server-supplied, and Angular
        interpolation escapes it. Never switch this to [innerHTML] / DomSanitizer / a markdown pipe —
        see announcement-banner.md.
      -->
      <span class="announcement-banner__message" data-testid="announcement-banner-message">
        {{ v.message }}
      </span>
    </div>

    @if (v.dismissible) {
      <button
        type="button"
        class="announcement-banner__dismiss"
        [attr.aria-label]="v.dismissLabel"
        data-testid="announcement-banner-dismiss"
        (click)="onDismiss(v.id)"
      >
        <lucide-icon [img]="icons.X" class="announcement-banner__dismiss-icon" aria-hidden="true" />
      </button>
    }
  </div>
}
